import _ from 'lodash';
import template from './humanDentalArches.html';
import { zubi, veze, findZub, findVeza } from './zubi.svg.js';

class HumanDentalArchesController {
    constructor() {
        this.plan = { pozicije: [], veze: [] };
        this.selected = [];
    }

    getSelected() {
        return this.plan.pozicije.filter(zub => zub.selected === true).map(zub => zub.id);
    }

    refreshPlan() {
        return {
            pozicije: zubi.map(item => {
                const zub = Object.assign({}, item, { filled: false, selected: false });
                if (this.data && this.data.pozicije) {
                    zub.filled = _.findIndex(this.data.pozicije, i => i.id === zub.id) > -1;
                }
                zub.selected = _.findIndex(this.selected, i => i === zub.id) > -1;
                return zub;
            }),
            veze: veze.map(item => {
                const veza = Object.assign({}, item, { active: false });
                if (this.data && this.data.veze) {
                    veza.active = _.findIndex(this.data.veze, i => i.id === veza.id && i.celjust === veza.celjust) > -1;
                }
                return veza;
            })
        };
    }

    $onChanges() {
        this.plan = this.refreshPlan();
    }

    pozicijaClicked(pozicija) {
        let poz = _.findIndex(this.selected, i => i === pozicija);
        if (poz !== -1) {
            this.selected.splice(poz, 1);
        } else {
            this.selected.push(pozicija);
        }
        this.plan = this.refreshPlan();
    }

    getVezeZaCeljust(celjust) {
        const elementi = [];

        if (celjust.length === 0) {
            return [];
        }

        const min_G = _.minBy(celjust, 'rbr');
        const max_G = _.maxBy(celjust, 'rbr');

        _.range(min_G.rbr, max_G.rbr).map(i => {
            const veza = findVeza(i, min_G.celjust);
            if (veza !== null && veza !== undefined) {
                elementi.push(veza);
            }
        });

        return elementi;
    }

    vezaBtnClicked() {
        let celjustG = [];
        let celjustD = [];
        const selected = this.getSelected();
        selected.map(s => {
            const zub = findZub(s);
            if (zub.celjust === 'G') {
                celjustG.push(zub);
            }

            if (zub.celjust === 'D') {
                celjustD.push(zub);
            }
        });

        this.getVezeZaCeljust(celjustG).map(v => {
            this.onVezaBtnClicked({ veza: v });
        });

        this.getVezeZaCeljust(celjustD).map(v => {
            this.onVezaBtnClicked({ veza: v });
        });

        this.selected = [];
    }

    onBtnNovaStavkaClicked() {
        const selected = this.getSelected();
        this.onNoveStavke({ pozicije: [...selected] });
        this.selected = [];
    }
}

HumanDentalArchesController.$inject = [];

const HumanDentalArchesComponent = {
    restrict: 'E',
    templateUrl: template,
    controller: HumanDentalArchesController,
    controllerAs: 'vm',
    bindings: {
        data: '<',
        onNoveStavke: '&',
        onVezaBtnClicked: '&'
    }
};

export { HumanDentalArchesComponent };
export { HumanDentalArchesController };



// WEBPACK FOOTER //
// ./app/components/radniNalog/humanDentalArches.component.js